// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kAhu","title":"styles_title__1kHy0"};